import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@fontsource-variable/inter/wght.css';
import '@fontsource/cormorant-garamond/latin-400.css';
import '@fontsource/cormorant-garamond/latin-500.css';
import '@fontsource/cormorant-garamond/latin-600.css';
import '@fontsource/great-vibes/latin-400.css';
import './styles/globals.css';

import { App } from './app/App';
import { startMonitoring } from './lib/monitoring';

// No-ops unless VITE_SENTRY_DSN is set; never blocks the first render.
void startMonitoring();

const container = document.getElementById('root');
if (!container) throw new Error('Root element missing');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
